const TYPES = {
    FETCH_START:    '[STATISTICS][TICKETS] FETCH START',
    FETCH_SUCCESS:  '[STATISTICS][TICKETS] FETCH SUCCESS'
};

export default TYPES;